import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  Card,
  Grid,
  Typography,
  Container,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import routes from "../../routes";
import nucleusxp from "nucleusxp";

const App = () => {
  const navigate = useNavigate();
  const [healths, setHealths] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClick = (text) => {
    switch (text) {
      case "Holidays & Overtime":
        navigate(routes.myHolidays.path);
        break;
      case "Health & Safety":
        navigate(routes.healthSafety.path);
        break;
      case "Documents":
        navigate(routes.documents.path);
        break;
      default:
        console.log("No navigation defined for this item.");
    }
  };

  const handleLogout = async () => {
    await nucleusxp.logout();
    navigate(routes.login.path);
  };

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        const response = await nucleusxp.healthSafety.getReports();
        const reports = response?.items || [];
        setLoading(false);
        setHealths(reports);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    };
    fetchReports();
  }, []);

  const holidays = JSON.parse(localStorage.getItem("holiday")) || [];
  const overtimes = JSON.parse(localStorage.getItem("overtime")) || [];

  const entitled = holidays.filter((item) => item.status !== "");
  const remainings = holidays.filter((item) => item.status === "Approved");
  const pendings = holidays.filter((item) => item.status === "Pending");

  const entitled_overtimes = overtimes.filter((item) => item.status !== "");
  const remainings_overtimes = overtimes.filter(
    (item) => item.status === "Approved",
  );
  const pendings_overtimes = overtimes.filter(
    (item) => item.status === "Pending",
  );

  const healthEntitled = healths.filter(
    (item) => item.status !== "" && item.reportType !== "",
  );
  const healthRemainings = healths.filter((item) => item.status === "Approved");
  const healthPendings = healths.filter((item) => item.status === "Pending");

  const menus = [
    { text: "My list", icon: "projects", path: null },
    { text: "Projects", icon: "inbox", path: null },
    { text: "Stock inventory", icon: "inbox", path: null },
    { text: "Requisitions", icon: "inbox", path: null },
    { text: "Documents", icon: "inbox", path: routes.documents.path },
    { text: "Address book", icon: "address", path: null },
    { text: "Resources", icon: "inbox", path: null },
    { text: "Work orders", icon: "inbox", path: null },
    { text: "Calendar", icon: "inbox", path: null },
    {
      text: "Holidays & Overtime",
      icon: "projects",
      path: routes.myHolidays.path,
      items: [
        {
          name: "Pending",
          count: pendings.length + pendings_overtimes.length,
        },
        {
          name: "Active",
          count: remainings.length + remainings_overtimes.length,
        },
        {
          name: "Completed",
          count: entitled.length + entitled_overtimes.length,
        },
      ],
    },
    {
      text: "Health & Safety",
      icon: "inbox",
      path: routes.healthSafety.path,
      items: [
        {
          name: "Pending",
          count: healthPendings.length,
        },
        {
          name: "Active",
          count: healthRemainings.length,
        },
        {
          name: "Completed",
          count: healthEntitled.length,
        },
      ],
    },
  ];

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100vh",
        overflowY: "auto",
        paddingBottom: "56px",
        backgroundColor: "#ecf0f7",
      }}
    >
      <Box sx={{ mt: 10, mb: 2, textAlign: "center" }}>
        <Box
          sx={{
            border: "1px solid lightgray",
            padding: 2,
            borderRadius: 1,
            color: "red",
            fontSize: 16,
          }}
        >
          Notification and link to inbox
        </Box>
      </Box>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        {menus.map((menu, index) => (
          <Grid item xs={12} key={menu.text}>
            <Card sx={{ borderRadius: "10px" }}>
              <Button
                sx={{
                  padding: 2,
                  textAlign: "center",
                  color: "#2D3648",
                  border: "1px solid #CAD3E7",
                  borderRadius: "10px",
                  width: "100%",
                  height: "166px",
                  boxShadow: "0px 3px 6px 0px #D8DFEE",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "19.6px",
                  textTransform: "capitalize",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
                onClick={() => handleClick(menu.text)}
              >
                <Grid container spacing={2} sx={{ width: "100%" }}>
                  <Grid item xs={8}>
                    <Grid
                      container
                      direction="column"
                      spacing={3}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Grid item>
                        <Typography
                          variant="h6" // Larger font size than body1
                          sx={{
                            fontWeight: 700, // Bold
                            fontSize: "16px", // Exact size (can be adjusted)
                            color: "#2D3648", // Dark text color
                            lineHeight: "20px", // Match height
                          }}
                        >
                          {menu.text}
                        </Typography>
                      </Grid>
                      <Grid item sc>
                        <Grid container spacing={0.5}>
                          {menu.items
                            ? menu.items.map((item, idx) => (
                                <Grid item xs={4} key={idx}>
                                  <Box
                                    sx={{
                                      height: "40px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      // border: "1px solid #CAD3E7",
                                      // borderRadius: "4px",
                                      // backgroundColor: "#f3f6f9",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      component="span"
                                      sx={{
                                        fontSize: "0.75rem",
                                        marginTop: "-5px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      {item.name}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      component="span"
                                      sx={{
                                        marginTop: "-5px",
                                        fontWeight: "bold",
                                        fontSize: "1rem",
                                        color:
                                          idx % 3 === 0
                                            ? "blue"
                                            : idx % 3 === 1
                                              ? "green"
                                              : "orange",
                                      }}
                                    >
                                      {item.count}
                                    </Typography>
                                  </Box>
                                </Grid>
                              ))
                            : ""}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/${menu.icon}-icon.svg`}
                      alt="Projects"
                      style={{ width: "166px", height: "166px" }}
                    />
                  </Grid>
                </Grid>
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 2, textAlign: "center", marginBottom: "60px" }}>
        <Button
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "24px",
            borderRadius: "10px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            textTransform: "capitalize",
            width: "100%",
            height: "54px",
            color: "#1C1468",
            gap: "8px",
          }}
        >
          Add Button +
        </Button>
      </Box>

      <Box sx={{ mt: 2, textAlign: "center", marginBottom: "60px" }}>
        <Button
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "24px",
            borderRadius: "10px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            textTransform: "capitalize",
            width: "100%",
            height: "54px",
            color: "#1C1468",
            gap: "8px",
          }}
          onClick={() => handleLogout()}
        >
          Logout
        </Button>
      </Box>

      <AppBar
        position="fixed"
        sx={{
          top: "auto",
          bottom: 0,
          bgcolor: "white",
        }}
      >
        <BottomNavigation showLabels>
          <BottomNavigationAction label="Home" icon={<HomeIcon />} />
          <BottomNavigationAction label="Search" icon={<SearchIcon />} />
          <BottomNavigationAction label="Contact" icon={<ContactMailIcon />} />
          <BottomNavigationAction
            label="Profile"
            icon={<AccountCircleIcon />}
          />
        </BottomNavigation>
      </AppBar>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default App;
